var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"none","width":"24","height":"24","key":0}),React.createElement("path",{"style":{"fill":"#054FD0"},"d":"M11.82,11.76,21,20.92l9.18-9.16L33,14.58l-12,12-12-12Z","transform":"translate(-9 -6.76)","key":1})]);
}

ArrowDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
